import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../api/client';
import type { HomepageContent } from '../api/admin';

// Public homepage content, editable from the admin Homepage CMS (PRD 6.19).
// Components fall back to their built-in copy while this loads or if it fails.
export function useHomepageContent() {
  return useQuery<HomepageContent>({
    queryKey: ['homepage'],
    queryFn: () => apiGet<HomepageContent>('/homepage'),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
